import React from "react";
import 'avado-components/src/sass/avado.sass'
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./pages/Home.js";
import ManualInstall from "./pages/ManualInstall.js";
import LightClient from "./pages/light-client";
import Troubleshoot from "./pages/Troubleshoot";

const App = () => {
    return (
        <div className="App">
            <BrowserRouter>
                <Switch>
                    <Route path="/" render={props => <Home {...props} />} exact />
                    <Route path="/provisioning/:provisioningprofile?" render={props => <Home {...props} />} exact />
                    <Route
                        path="/install/:hash?"
                        render={props => <ManualInstall {...props} />}
                        exact
                    />
                    <Route
                        path="/install/ipfs/:hash?"
                        render={props => <ManualInstall {...props} />}
                        exact
                    />
                    <Route
                        path="/ipfs/:hash?"
                        render={props => <ManualInstall {...props} />}
                        exact
                    />
                    <Route
                        path="/light-client"
                        render={props => <LightClient {...props} />}
                        exact
                    />
                    <Route
                        path="/troubleshoot"
                        render={props => <Troubleshoot {...props} />}
                        exact
                    />
                </Switch>
            </BrowserRouter>
        </div>
    );
}

export default App;
